// @ts-check
const messages = {
    OPEN: 'open',
    SHUT: 'shut',
    REQUEST_STATUS: 'request_status',
    STATUS_RESPONSE: 'status_response',
};
Object.freeze(messages);
export default messages;
